import { render, staticRenderFns } from "./UserTypeView.vue?vue&type=template&id=60bd29d8&scoped=true"
import script from "./UserTypeView.vue?vue&type=script&lang=js"
export * from "./UserTypeView.vue?vue&type=script&lang=js"
import style0 from "./UserTypeView.vue?vue&type=style&index=0&id=60bd29d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd29d8",
  null
  
)

export default component.exports